import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryList`

export default defineMessages({
  currentSpendHeader: {
    id: `${scope}.currentSpendHeader`,
    defaultMessage: 'Current Spend',
  },
  emptyStateButtonText: {
    id: `${scope}.emptyStateButtonText`,
    defaultMessage: 'Budget',
  },
  emptyStateContent: {
    id: `${scope}.emptyStateContent`,
    defaultMessage:
      'Approvers will see spend reports while approving pending requests',
  },
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: 'Start tracking spend by creating a budget',
  },
  budgetHeader: {
    id: `${scope}.budgetHeader`,
    defaultMessage: 'Budget',
  },
  budgetCategoryHeader: {
    id: `${scope}.budgetCategoryHeader`,
    defaultMessage: 'Budget Category',
  },
  nameHeader: {
    id: `${scope}.nameHeader`,
    defaultMessage: 'Name',
  },
  percentageHeader: {
    id: `${scope}.percentageHeader`,
    defaultMessage: '%',
  },
  remainingHeader: {
    id: `${scope}.remainingHeader`,
    defaultMessage: 'Remaining',
  },
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Budget list table',
  },
})
